type LeaveSignupModalProps = {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
};

export function LeaveSignupModal({ open, onStay, onLeave }: LeaveSignupModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Dismiss"
        className="absolute inset-0 cursor-pointer border-none bg-[#0F1817]/35 backdrop-blur-[2px]"
        onClick={onStay}
      />
      <div className="relative z-10 w-full max-w-[400px] overflow-hidden rounded-2xl border border-[#E2E9E7] bg-[#FBFCFC] shadow-[0_20px_48px_-24px_rgba(11,51,46,0.35)]">
        <div className="border-b border-[#E2E9E7] px-5 py-4">
          <h3
            className="m-0 text-[18px] font-semibold tracking-[-0.01em] text-[#0F1817]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Leave this page?
          </h3>
          <p className="mt-1.5 mb-0 text-sm leading-relaxed text-[#7C8B88]">
            Your entered data may be lost. Are you sure you want to go back?
          </p>
        </div>
        <div className="flex items-center justify-end gap-2.5 px-5 py-4">
          <button
            type="button"
            onClick={onStay}
            className="h-10 rounded-[9px] border border-[#E2E9E7] bg-white px-4 text-sm font-semibold text-[#3E524F] transition-colors hover:border-[#C9D3D1] hover:bg-[#F2F5F4]"
          >
            Stay
          </button>
          <button
            type="button"
            onClick={onLeave}
            className="h-10 rounded-[9px] border-none bg-[#E11D48] px-4 text-sm font-semibold text-white transition-opacity hover:opacity-90"
          >
            Yes, leave
          </button>
        </div>
      </div>
    </div>
  );
}
